import React, { useEffect } from 'react';
import clsx from 'clsx';
import _ from 'underscore';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, TextField, colors } from '@mui/material';
import DatePicker from 'components/DatePicker/DatePicker';
import validate from 'validate.js';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { enqueueSnackbar } from 'actions';
import { TopOffendersAggSiteExport, SetFormState } from '../../actions/TopOffendersAggSiteActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const schema = {
	Site: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	StartDate: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	EndDate: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const TopOffendersAggSiteForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.TopOffendersAggSiteReducer.formState);

	useEffect(() => {
		const errors = validate(formState.values, schema);

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	const _handleChange = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _handleDateChange = (value, name) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: value,
			},
			touched: {
				...formState.touched,
				[name]: true,
			},
		});
	};

	const _hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));
	const user = useSelector(state => state.session.user);
	const _generate = () => {
		dispatch(TopOffendersAggSiteExport(formState.values, user.id));
	};

	return (
		<Card className={classes.content}>
			<CardContent>
				<Grid container spacing={1}>
					<Grid item md={8} xs={12}>
						<TextField
							fullWidth
							label="Site(s) List"
							name="Site"
							onChange={_handleChange}
							value={formState.values.Site}
							variant="outlined"
							error={_hasError('Site')}
							helperText={
								_hasError('Site') ? formState.errors.Site[0] : 'Example: 14152,50345,90072 (Max 4000 sites)'
							}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<DatePicker
							label="Start Period Date"
							name="StartDate"
							value={formState.values.StartDate || null}
							onChange={(value) => _handleDateChange(value, 'StartDate')}
							error={_hasError('StartDate')}
							helperText={_hasError('StartDate') ? formState.errors.StartDate[0] : null}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<DatePicker
							label="End Period Date"
							name="EndDate"
							value={formState.values.EndDate || null}
							onChange={(value) => _handleDateChange(value, 'EndDate')}
							error={_hasError('EndDate')}
							helperText={_hasError('EndDate') ? formState.errors.EndDate[0] : null}
						/>
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Button className={classes.generate} onClick={_generate} variant="contained" disabled={!formState.isValid}>Export</Button>
			</CardActions>
		</Card>
	);
};

export default TopOffendersAggSiteForm;
